export default "__VITE_ASSET__7bb1b1fd__"